document.addEventListener('DOMContentLoaded', () => {

    var startDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" }));

    var endDate = new Date(2023, 10, 22, 0, 0, 0, 0);


    var delta = Math.abs(startDate.getTime() - endDate.getTime()) / 1000;

    // Unix timestamp (in seconds) to count down to
    var daysLeft = (new Date().getTime() / 1000) + delta;


    // Set up FlipDown
    var flipdown = new FlipDown(daysLeft)

    // Start the countdown
    .start()

    // Do something when the countdown ends
    .ifEnded(() => {
        console.log('The countdown has ended!');
    });

   

});